import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.onreadystatechange = () => {
  if (document.readyState === "complete") {
    let swiperWrapper = new Swiper( '.collage-swiper__wrapper', {
      a11y: true,
      keyboard: {
        enabled: true,
      },
      slidesPerView: 'auto',
      spaceBetween: 24,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    } );
  }
}

